import {
  REQUEST_FAILED,
  REQUEST_GET_CUSTOM_APP_TEMPLATE,
  REFRESH_CUSTOM_APP_TEMPLATE,
  REQUEST_GET_CUSTOM_APP,
  REQUEST_UPDATE_CUSTOM_APP,
  REFRESH_CUSTOM_APP,
  REFRESH_CUSTOM_APP_USER_ACTIVITY,
  DELETE_USER_ACTIVITY_FOR_CUSTOM_APP,
  REFRESH_CUSTOM_APP_GOAL,
} from "../actions/customapps";

import { LOG_OUT } from "../actions/user";

const defaultState = {
  isLoading: false,
  customApps: {},
  goals: {},
  userActivity: [],
  customAppTemplates: {},
  programInstructions: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case REQUEST_GET_CUSTOM_APP_TEMPLATE:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_CUSTOM_APP_TEMPLATE:
      return {
        ...state,
        isLoading: false,
        customAppTemplates: {
          ...state.customAppTemplates,
          [action.appId]: action.appTemplate,
        },
      };
    case REQUEST_GET_CUSTOM_APP:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_UPDATE_CUSTOM_APP:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_CUSTOM_APP:
      return {
        ...state,
        isLoading: false,
        customApps: {
          ...state.customApps,
          [action.appId]: {
            ...state.customApps[action.appId],
            [action.appUserId]: action.customApp,
          },
        },
        programInstructions: action.programInstructions,
      };
    case REFRESH_CUSTOM_APP_USER_ACTIVITY:
      return {
        ...state,
        isLoading: false,
        userActivity: action.userActivity,
      };
    case DELETE_USER_ACTIVITY_FOR_CUSTOM_APP:
      const filteredActivityList = state.userActivity.filter(
        (item) => action.activityId !== item.userActivityId
      );
      const updateCustApps = state.customApps;
      updateCustApps[action.appId][action.userId].points = action.ptsTotal;
      return {
        ...state,
        isLoading: false,
        userActivity: filteredActivityList,
        customApp: updateCustApps,
      };
    case REFRESH_CUSTOM_APP_GOAL:
      return Object.assign({}, state, {
        isLoading: false,
        goals: {
          ...state.goals,
          [action.customAppId]: action.goal,
        },
      });

    case LOG_OUT:
      return {
        isLoading: false,
        customApps: {},
        goals: {},
        userActivity: [],
        customAppTemplates: {},
        programInstructions: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/customapps.js